import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { JoinToCommunityService, JoinCommunityDTO } from 'src/app/services/join-to-community.service';
import { AppService } from 'src/app/services/app.service';
import { Lang } from 'src/app/model/orm/lang.model';

@Component({
  selector: 'app-join-to-community',
  templateUrl: 'join-to-community.component.html',
  styleUrls: ['join-to-community.component.scss']
})
export class JoinToCommunityComponent implements OnInit {
  @Input() active: boolean = false;
  @Output() activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public email: string = '';
  public agreeToPrivacy: boolean = false;
  public isLoading: boolean = false;
  public isSuccess: boolean = false;
  public errorMessage: string = '';
  public emailError: string = '';

  constructor(
    private joinToCommunityService: JoinToCommunityService,
    private appService: AppService
  ) {}

  ngOnInit() {}

  get currentLang(): Lang {
    return this.appService.currentLang.value;
  }

  public close() {
    if (this.isSuccess) {
      localStorage.setItem('fof_subscribed', 'true');
    } else {
      const now = new Date().getTime();
      localStorage.setItem('fof_popup_hidden_until', (now + 24 * 60 * 60 * 1000).toString());
    }

    this.activeChange.emit(false);
    this.resetForm();
  }

  public onClick(event: MouseEvent | TouchEvent): void {
    const target: HTMLElement = event.target as HTMLElement;
    if (target.classList.contains('join-community-popup')) {
      this.close();
    }
  }

  private validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  public async subscribe(): Promise<void> {
    this.emailError = '';
    this.errorMessage = '';

    if (!this.email) {
      this.emailError = 'Поле email є обов\'язковим';
      return;
    }

    if (!this.validateEmail(this.email)) {
      this.emailError = 'Введіть коректний email';
      return;
    }

    if (!this.agreeToPrivacy) {
      this.errorMessage = 'Потрібно погодитись з політикою конфіденційності';
      return;
    }

    this.isLoading = true;

    const dto: JoinCommunityDTO = {
      email: this.email,
      agree_to_privacy: this.agreeToPrivacy
    };

    try {
      await this.joinToCommunityService.subscribe(dto).toPromise();
      this.isSuccess = true;
      setTimeout(() => {
        this.close();
      }, 2000);
    } catch (error) {
      this.errorMessage = (error as any).error?.message || 'Сталась помилка. Спробуйте пізніше.';
      this.isLoading = false;
    }
  }

  private resetForm(): void {
    this.email = '';
    this.agreeToPrivacy = false;
    this.isLoading = false;
    this.isSuccess = false;
    this.errorMessage = '';
    this.emailError = '';
  }
}
